<script lang="ts">
    import { cx } from '$lib/utils/cx.js';
    import sumBy from 'lodash/sumBy';
    import filter from 'lodash/filter';
    import sortBy from 'lodash/sortBy';
    import slice from 'lodash/slice';
    import { getReactionsData, type ReactionType } from './Utils';
    import * as t from '$trans';
    import { getContainer } from '$components/Context/ContainerContext';

    const { lang } = getContainer();
    export let counters: { type: string; count: number }[];
    export let className: string = '';
    export let showCountOnly: boolean = false;

    $: list = slice(
        sortBy(
            filter(counters, (counter) => counter.count > 0),
            (counter) => counter.count,
        ),
        0,
        3,
    ) as { count: number; type: ReactionType }[];
    $: sum = sumBy(counters, (counter) => counter.count);
    $: reactionsData = getReactionsData($lang);
</script>

{#if sum > 0}
    <button
        on:click
        class:pl-2={list.length > 1}
        class={cx('btn-reset bg-transparent flex items-center space-x-2', className)}
    >
        <span class={'flex items-center relative'}>
            {#each list as counter, index}
                <img
                    src={reactionsData.images[counter.type]}
                    alt={reactionsData.labels[counter.type]}
                    class={'h-8 w-8 relative'}
                    class:-ml-2={list.length > 1}
                    style={`z-index: ${list.length - index}`}
                />
            {/each}
        </span>
        <span>{showCountOnly ? sum : t.feed_post.x_reacted({ nb: sum }, $lang)}</span>
    </button>
{/if}
